import React, { useState } from "react";
import "./index.css";
import Modal from "../modal/Modal";
import swal from "sweetalert";
import { logout } from "../../Redux/Action/LoginAction/loginAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { closeAlert } from "../../Redux/Action/AlertPopUpAction/AlertPopUpAction";
import { BUSINESS_TYPE_SIGN_IN } from "../../Utils/constants";
import { WHY_BRIGIZ } from "../../Routes/RoutesConstant";

const AlertPopUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state?.alertReducer?.isOpen);
  const logoutButton = async () => {
    try {
      const response = await dispatch(logout());
      const logoutData = response?.payload;
      if (logoutData) {
        if (logoutData == "LOGOUT") {
          dispatch(closeAlert())
          navigate("/login", { state: { checkedVal: BUSINESS_TYPE_SIGN_IN } });
        } else {
          swal({
            title: "error!",
            text: logoutData?.data?.message,
            buttons: false,
            icon: "error",
            timer: 2000,
          });
        }
      }
    } catch (error) {
      swal({
        title: "Error",
        text: error?.message,
        buttons: false,
        icon: "error",
        timer: 2000,
      });
    }
  };
  return (
    <Modal
      closeIcon={false}
      isOpen={isOpen}
      onClose={() => { }}
      className="confirmation-modal"
    >
      <div className="confirmation-content">
        <div className="alert-icon-wrap">
          <i className="fas fa-exclamation-circle alert-icon" />
        </div>
        <div className="confirmation-message">
          <div>Sign Up with Business Account To Access This Feature.</div>
        </div>
        <div className="confirmation-buttons">
          <button
            className="confirm-button"
            onClick={() => {
              logoutButton();
            }}
          >
            Logout
          </button>
          <button onClick={() => dispatch(closeAlert())} className="cancel-button">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AlertPopUp;
